import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Header from "@/components/landing/Header";

const FAQ = lazy(() => import("@/components/landing/FAQ"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const FAQPage = () => {
  const { t } = useTranslation();
  const qa = [1, 2, 3, 4, 5, 6].map((i) => ({
    question: t(`faq.q${i}`),
    answer: t(`faq.a${i}`),
  }));

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>FAQ – PieFolio AI Portfolio Tracker</title>
        <meta
          name="description"
          content="Answers about PieFolio AI: is it a broker, supported markets, AI analysis, pricing, ethical screening, and data handling."
        />
        <link rel="canonical" href="https://getpiefolio.com/faq" />
        <link rel="alternate" type="text/markdown" href="https://getpiefolio.com/faq.md" />
        <meta property="og:title" content="PieFolio AI – Frequently Asked Questions" />
        <meta property="og:description" content="FAQ for PieFolio AI: is it a broker, supported markets, AI portfolio analysis, pricing, ethical screening, and how we handle your data." />
        <meta property="og:url" content="https://getpiefolio.com/faq" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: qa.map((q) => ({
              "@type": "Question",
              name: q.question,
              acceptedAnswer: { "@type": "Answer", text: q.answer },
            })),
          })}
        </script>
      </Helmet>
      <Header />
      <main className="pt-24">
        <header className="container mx-auto px-6 lg:px-12 max-w-4xl text-center py-12">
          <h1 className="text-4xl lg:text-6xl font-extrabold tracking-tight mb-6">
            Frequently asked <span className="text-gradient-sage">questions</span>
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Quick answers about how PieFolio AI works: what the app is and is not, which markets it supports,
            how you add holdings yourself without broker linking, how the AI portfolio analysis and Health Score are calculated, what is
            free and what is premium, the roadmap for Shariah screening, and how your data is stored and
            protected. If your question is not covered here, email us and we will add it.
          </p>
        </header>
        <Suspense fallback={null}>
          <FAQ />
          <Footer />
        </Suspense>
      </main>
    </div>
  );
};

export default FAQPage;
